import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/signature-pad'
//import "./plugins/veevalidate";
import VueMask from 'v-mask'

import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
  siteKey: '6LfC4yEpAAAAAKQhXlSwVgP0oPm4tfMjwGKX4Xcl',
  loaderOptions: {
    useRecaptchaNet: true
  }
})

Vue.use(VueMask)

//router.beforeEach((to, from, next) => {
//})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
